import React, { useCallback } from "react";
import { useField } from "formik";

import LogotypeInput from "components/InputsField/LogotypeInput";

const FormikLogotypeInput = (props) => {
    const [field, meta, helpers] = useField(props.name);

    const handleChangeFiled = useCallback(
        (value) => {
            helpers.setValue(value);
        },
        [helpers],
    );

    return (
        <LogotypeInput
            {...props}
            uploadedFile={field.value}
            onChange={handleChangeFiled}
            setTouched={helpers.setTouched}
            errorMessage={meta.touched && meta.error}
        />
    );
};

export default FormikLogotypeInput;
